var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_27944)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_258_27944",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.046875 0.970703H30.0469V30.9707H0.046875V0.970703Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_258_27944)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6807 7.58682C30.1689 8.07498 30.1689 8.86643 29.6807 9.35459L17.8057 21.2296C17.3176 21.7177 16.5261 21.7177 16.038 21.2296L10.6719 15.8635L2.18076 24.3546C1.6926 24.8427 0.901146 24.8427 0.412991 24.3546C-0.0751638 23.8665 -0.0751638 23.075 0.412991 22.5868L9.78799 13.2118C10.2761 12.7237 11.0676 12.7237 11.5558 13.2118L16.9219 18.578L27.913 7.58682C28.4011 7.09867 29.1926 7.09867 29.6807 7.58682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0469 8.4707C20.0469 7.78035 20.6065 7.2207 21.2969 7.2207H28.7969C29.4873 7.2207 30.0469 7.78035 30.0469 8.4707V15.9707C30.0469 16.6611 29.4873 17.2207 28.7969 17.2207C28.1065 17.2207 27.5469 16.6611 27.5469 15.9707V9.7207H21.2969C20.6065 9.7207 20.0469 9.16105 20.0469 8.4707Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_27944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.046875 0.970703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow-white.96dbc46d573e0566763bfe22a6d97562.svg";
export { ForwardRef as ReactComponent };